import React, { Fragment } from 'react'
import useStyles from './styles'
import Item from './Item'
import { Typography, Box, useMediaQuery } from '@material-ui/core'
import EventNoun from 'components/EventNoun'
import { useSelector } from 'react-redux'
import AutoSizer from 'react-virtualized-auto-sizer'
import Scrollbars from 'react-scrollbars-custom'

const ItemsList = () => {
  const classes = useStyles()

  const isMobile = useMediaQuery('(max-width: 767px)')

  const items = useSelector(state => state.items.items)
  let currentItems = items.filter(
    x => x.status !== 2 && !x.is_live && x.published
  )
  let closedItems = items.filter(x => x.status === 2 && x.published)

  return (
    <Box className={classes.itemsList}>
      <AutoSizer>
        {({ height, width }) => (
          <Scrollbars
            style={{
              height,
              width
            }}
            disableTracksWidthCompensation
            permanentTracks={false}
            trackYProps={{
              className: 'testing'
            }}
            noScroll={isMobile}
          >
            {currentItems && currentItems.length > 0 && (
              <Fragment>
                <Typography variant="h2" className={classes.comingUpTypography}>
                  Coming Up!
                </Typography>
                <div className={classes.listWrapper}>
                  {currentItems.map(item => (
                    <Item key={item.item_id} item={item} />
                  ))}
                </div>
              </Fragment>
            )}
            {closedItems && closedItems.length > 0 && (
              <Fragment>
                <Typography variant="h2" className={classes.comingUpTypography}>
                  Closed <EventNoun />
                </Typography>
                <div className={classes.listWrapper}>
                  {closedItems.map(item => (
                    <Item key={item.item_id} item={item} showWinner />
                  ))}
                </div>
              </Fragment>
            )}
          </Scrollbars>
        )}
      </AutoSizer>
    </Box>
  )
}

export default ItemsList



// WEBPACK FOOTER //
// ./src/components/ItemsList/index.jsx